import api, { ApiCallReturn } from '../api';

export const getNotificationCenter = (): ApiCallReturn => api.get('/notification-center');
export const getNotificationCenterList = (limit: number, offset: number, category_id: number|string): ApiCallReturn => api.get('/notification-center/list', {params: {limit, offset, category_id}});
export const postNotificationCenterRead = (notificationCenterId: number): ApiCallReturn => api.post(`/notification-center/${notificationCenterId}/read`);
export const postNotificationCenterAllRead = (): ApiCallReturn => api.post('/notification-center/all/read');
